import { mapState, mapActions, mapMutations } from "vuex"
import Util from '../../util/funcoes'

export default {
  data() {
    return {
      isLoading: false,
    }
  },

  created() {
    this.listar();
  },

  computed: {
    ...mapState('contasReceberDoDiaStore', {
      contasReceberDoDia(state) { return state.listaDeContasReceberDoDia }
    }),

    tooltipQuantidadeContasIsVisible() {
      return this.contasReceberDoDia.length > 0;
    },

    quantidadeContas() {
      const quantidade = this.contasReceberDoDia.length;

      switch (quantidade) {
        case 1:
          return 'Exibindo 1 lançamento.'
        default:
          return `Exibindo ${quantidade} lançamentos.`
      }
    }
  },

  methods: {
    ...mapActions('contasReceberDoDiaStore', [
      'recuperarContasReceberDoDia'
    ]),
    ...mapMutations('contasReceberDoDiaStore', [
      'limparContasReceber'
    ]),

    listar() {
      this.showLoading();
      this.limparContasReceber();
      this.recuperarContasReceberDoDia()
      .then()
      .finally(() => {
        this.hideLoading();
      })
    },

    showLoading() {
      this.isLoading = true;
    },
    hideLoading() {
      this.isLoading = false;
    },

    formatarLabelValor(item) {
      return Util.formatarValor(item.valor);
    },
  }
}